'use client';

import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { RHFSwitch } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { useTranslate } from 'src/locales';

export default function LastMinuteOptIn() {
  const methods = useFormContext();
  const { watch } = methods;
  const { t: tEvent } = useTranslate('event');
  const lastMinuteOptIn = watch('lastMinuteOptIn') || false;

  return (
    <Box
      sx={{
        px: 2.5,
        py: 2.5,
        mt: 2,
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        borderRadius: 2,
        border: '1px solid rgba(255, 255, 255, 0.1)',
        transition: 'all 0.2s ease',
        position: 'relative',
        overflow: 'hidden',
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.07)',
        },
      }}
    >
      <Stack direction="column" spacing={2}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 600,
              color: 'white',
              transition: 'color 0.2s ease',
              ...(lastMinuteOptIn && {
                background: `linear-gradient(90deg, #fff, #FFD369)`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }),
            }}
          >
            {tEvent('last-minute.title')}
          </Typography>
          <Tooltip title={tEvent('last-minute.tooltip')} placement="top" arrow>
            <Box component="span" sx={{ display: 'flex', alignItems: 'center', cursor: 'help' }}>
              <Iconify
                icon={lastMinuteOptIn ? 'ic:round-help' : 'ic:round-help-outline'}
                sx={{
                  fontSize: 18,
                  color: lastMinuteOptIn ? '#FFD369' : 'grey.400',
                  transition: 'color 0.2s ease',
                }}
              />
            </Box>
          </Tooltip>
        </Stack>

        <RHFSwitch
          name="lastMinuteOptIn"
          label={
            <Typography
              variant="body2"
              sx={{
                color: lastMinuteOptIn ? '#fff' : 'grey.300',
                transition: 'color 0.2s ease',
                fontWeight: lastMinuteOptIn ? 500 : 400,
              }}
            >
              {tEvent('last-minute.label')}
            </Typography>
          }
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: '#FFD369',
            },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: 'rgba(255, 211, 105, 0.5)',
            },
          }}
        />

        <Box
          sx={{
            p: 1.5,
            borderRadius: 1,
            backgroundColor: lastMinuteOptIn
              ? 'rgba(255, 211, 105, 0.08)'
              : 'rgba(255, 255, 255, 0.03)',
            borderLeft: lastMinuteOptIn
              ? '3px solid #FFD369'
              : '3px solid rgba(255, 255, 255, 0.1)',
            transition: 'all 0.3s ease-in-out',
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: lastMinuteOptIn ? '#FFD369' : 'grey.400',
              fontStyle: 'italic',
              transition: 'color 0.2s ease',
              display: 'block',
            }}
          >
            {lastMinuteOptIn
              ? tEvent('last-minute.caption.enabled')
              : tEvent('last-minute.caption.disabled')}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}
